import { IS_COLOR_THEME_DARK as localStorageKey } from '../KEYS';

export default {
  get(): boolean {
    return localStorage.getItem(localStorageKey) === JSON.stringify(true);
  },

  set(value: boolean) {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  },
};
